/* eslint-disable */
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

export const DeleteModal = ({ deleteWord = 'item', modalState, setModalState, selectedRow, deleteBeneficiary = () => {} }) => {
    return (
        <Dialog open={modalState} onClose={() => setModalState(false)}>
            <DialogTitle sx={{ fontSize: '1.2rem' }}>Delete {deleteWord}</DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ fontWeight: 500, color: 'black' }}>
                    Are you sure you want to delete this {deleteWord}?
                    <br />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setModalState(false)} color="primary">
                    Cancel
                </Button>
                <Button
                    onClick={() => {
                        if (selectedRow) deleteBeneficiary(selectedRow);
                        setModalState(false);
                    }}
                    color="error"
                    variant="contained"
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};
